(() => {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var doc = document.documentElement;
  var revealSelector = [
    '.main-collection-grid product-card',
    '.main-collection-grid .product-card',
    '.product-grid__item',
    '.resource-list__item',
    '.product-information .product-information__media',
    '.product-information .product-details > *',
    '.cart-page .cart-items__table-row',
    '.cart-page__summary',
    '.stylist-cart-service__block',
    '.footer-utilities',
    'footer .shopify-section'
  ].join(',');

  var sectionSelector = '#MainContent > .shopify-section';
  var seen = new WeakSet();
  var observer;

  function isFineSection(element) {
    return !element.querySelector('.main-collection-grid, .product-information, .cart-page, product-card, .product-card');
  }

  function markVisible(element) {
    element.classList.add('stylist-reveal--visible');
    if (observer) observer.unobserve(element);
  }

  function markVisibleSoon(element, delay) {
    window.setTimeout(function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          markVisible(element);
        });
      });
    }, delay || 0);
  }

  function prepare(element, index, pendingVisibilityChecks) {
    if (!element || seen.has(element)) return;
    seen.add(element);
    element.classList.add('stylist-reveal');
    element.style.setProperty('--stylist-reveal-index', String(index % 10));

    if (reduceMotion) {
      markVisible(element);
      return;
    }

    pendingVisibilityChecks.push({ element: element, index: index });
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var items = [];
    scope.querySelectorAll(sectionSelector).forEach(function (section) {
      if (isFineSection(section)) items.push(section);
    });
    scope.querySelectorAll(revealSelector).forEach(function (element) {
      items.push(element);
    });

    var pendingVisibilityChecks = [];
    items.forEach(function (element, index) {
      prepare(element, index, pendingVisibilityChecks);
    });

    if (!pendingVisibilityChecks.length) return;

    // All classes/styles are written first and geometry is read in one frame.
    // This avoids repeated synchronous layout recalculation on long grids.
    requestAnimationFrame(function () {
      pendingVisibilityChecks.forEach(function (item) {
        var rect = item.element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) {
          markVisibleSoon(item.element, 20 + ((item.index % 6) * 25));
        } else if (observer) {
          observer.observe(item.element);
        } else {
          markVisible(item.element);
        }
      });
    });
  }

  function boot() {
    doc.classList.add('stylist-motion-booting');

    if (!reduceMotion && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) markVisibleSoon(entry.target, 0);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    }

    scan(document);
    requestAnimationFrame(function () {
      doc.classList.add('stylist-motion-ready');
      doc.classList.remove('stylist-motion-booting');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
